import { post, postFile } from "@/http/index.js";
import { MEMBER,MEETING } from "@/utils/http.js";

/**
 * 上传文件
 */
export const uploadFile = params => postFile(MEMBER + "/file/upload", params);
//上传
export const fileuploadUrl = MEMBER + "/file/upload";

export const uploadURL = MEETING + "/file/meetingUpload";

/**
 * 删除文件
 * @param {*} id
 */
export const delFile = params => post(MEMBER + "/file/delete", params,true);
